// ============================================================
//  KAJU STEIN-FINDER – ZENTRALE KONFIGURATION
//  Datei: assets/kaju-config.js
//
//  HIER alles einstellen:
//  - Reihenfolge & Farben der Steine
//  - Begrüßungstexte pro Stein
//  - Fragen & Antwortoptionen
//  - Bild-URLs (Shopify CDN)
//  - n8n Webhook URL
//  - Seiten-Hints für das Logo-Popup
// ============================================================

window.KAJU_CONFIG = {

  // ----------------------------------------------------------
  // n8n Webhook – empfängt alle Antworten
  // ----------------------------------------------------------
  webhookUrl: 'https://n8n.kaju-spielbausteine.de/webhook/kaju-stein',

  // ----------------------------------------------------------
  // SSE – Live Chat (Server-Sent Events)
  // Browser hält Verbindung offen, Server pusht Nachrichten
  // ----------------------------------------------------------
  sseUrl: 'https://n8n.kaju-spielbausteine.de/sse',

  // ----------------------------------------------------------
  // Avatar – Foto des Inhabers
  // ----------------------------------------------------------
  avatarUrl: 'https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/kaju-avatar.jpg',

  /* Änderung Start stein-finder-umfrage */
  // ----------------------------------------------------------
  // Online-Status: true = grüner Punkt, false = grau
  // Hier manuell umschalten wenn du nicht erreichbar bist
  // ----------------------------------------------------------
  online: true,
  /* Änderung Ende stein-finder-umfrage */

  // ----------------------------------------------------------
  // Erfolgs-Nachricht (gilt für alle Steine)
  // ----------------------------------------------------------
  successText: 'Deinen Gratis-Stein lege ich dir in den Warenkorb. Schau weiter, es gibt noch mehr! Für einen Tipp klick oben auf das LOGO.',

  // ----------------------------------------------------------
  // Absenden-Button Text
  // ----------------------------------------------------------
  sendLabel: 'Senden',

  // ----------------------------------------------------------
  // Seiten-Reihenfolge für Hints im Logo-Popup
  //
  // Der Tipp zeigt immer die nächste noch nicht besuchte Seite.
  // Mehr Einträge als Steine möglich – gibt mehrere Wege.
  // {link} wird automatisch durch einen klickbaren Link ersetzt.
  // ----------------------------------------------------------
  seiten: [
    {
      url:   'https://www.kaju-spielbausteine.de/',
      label: 'Startseite',
      hint:  'Vielleicht schaust du mal auf der {link}! Ich hab da was gesehen, denke ich.'
    },
    {
      url:   'https://www.kaju-spielbausteine.de/pages/herstellung',
      label: 'Herstellung',
      hint:  'Ich glaube, ein Stein ist auch in die Werkstatt gepurzelt – schau doch mal auf der Seite zur {link}.'
    },
    {
      url:   'https://www.kaju-spielbausteine.de/pages/uber-uns',
      label: 'Unsere Geschichte',
      hint:  'Da hab\'s gesehen, einer ist auch auf unsere {link} Seite gekullert.'
    },
    {
      url:   'https://www.kaju-spielbausteine.de/pages/padagogischer-wert',
      label: 'Wie es funktioniert',
      hint:  'Drüben auf der Seite {link} habe ich was klackern gehört!'
    },
    {
      url:   'https://www.kaju-spielbausteine.de/collections/all',
      label: 'Produktübersicht',
      hint:  'Ach, im Lager haben wir noch nicht geschaut – vielleicht zwischen den ganzen Kisten auf {link}.'
    },
    // Alternativ-Seite – Reihenfolge hier ändern um anderen Weg zu nutzen
    {
      url:   'https://www.kaju-spielbausteine.de/products/murmelbundle',
      label: 'Bogenwelten-Bundle',
      hint:  'Hast du auch dieses Kullern von Holzmurmeln gehört? Schauen wir doch mal beim {link}.'
    },
  ],

  // ----------------------------------------------------------
  // Steine – Reihenfolge = Fundfolge (Index 0 = zuerst gefunden)
  // Mehr Sektionen als Steine möglich – jede zeigt den nächsten.
  // ----------------------------------------------------------
  steine: [
    // ── Stein 🟡 (gelb) ───────────────────────────────────────
    {
      id:    'gelb',
      emoji: '🟡',
      farbe: '#f1c953',
      textFarbe: '#1a1a1a',
      logoFarbe: '#f1c953',

      bildUrl: 'https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/stein-gelb.png',
      bubble: 'Hehe, ich bin gut versteckt!',

      titel:      'Du hast einen Stein gefunden!',
      untertitel: 'Hey, schön dass du hier vorbeischaust!',

      frage: 'Wo hast du kajuSPIELBAUSTEINE zum ersten Mal wahrgenommen?',

      optionen: [
        { label: 'Instagram', wert: 'Instagram' },
        { label: 'TikTok', wert: 'TikTok' },
        { label: 'Freunde / Empfehlung', wert: 'Empfehlung' },
        { label: 'Anderes…', wert: '__other__' },
      ],
    },

    // ── Stein 🔵 (tuerkis) ───────────────────────────────────────
    {
      id:    'tuerkis',
      emoji: '🔵',
      farbe: '#0096ae',
      textFarbe: '#ffffff',
      logoFarbe: '#0096ae',

      bildUrl: 'https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/stein-tuerkis.png',
      bubble: 'Psst… hier bin ich!',

      titel:      'Du hast einen Stein gefunden!',
      untertitel: 'Hey, schön dass du in meine Werkstatt reinschaust!',

      frage: 'Kaufst du für eine Kita oder privat?',

      optionen: [
        { label: 'Für eine Kita / Kindergruppe', wert: 'Kita' },
        { label: 'Privat für zuhause', wert: 'Privat' },
        { label: 'Als Geschenk', wert: 'Geschenk' },
        { label: 'Anderes…', wert: '__other__' },
      ],
    },

    // ── Stein 🔴 (rot) ───────────────────────────────────────
    {
      id:    'rot',
      emoji: '🔴',
      farbe: '#a93015',
      textFarbe: '#ffffff',
      logoFarbe: '#a93015',

      bildUrl: 'https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/stein-rot.png',
      bubble: 'Du hast ein gutes Auge!',

      titel:      'Du hast einen Stein gefunden!',
      untertitel: 'Schön, dass du so neugierig bist!',

      frage: 'Was ist dir bei Spielzeug für Kinder am wichtigsten?',

      optionen: [
        { label: 'Natürliche Materialien', wert: 'Materialien' },
        { label: 'Langlebigkeit', wert: 'Langlebigkeit' },
        { label: 'Kreativität fördern', wert: 'Kreativitaet' },
        { label: 'Anderes…', wert: '__other__' },
      ],
    },

    // ── Stein 🟢 (gruen) ───────────────────────────────────────
    {
      id:    'gruen',
      emoji: '🟢',
      farbe: '#6cac53',
      textFarbe: '#ffffff',
      logoFarbe: '#6cac53',

      bildUrl: 'https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/stein-gruen.png',
      bubble: 'Darf ich dich noch was fragen?',

      titel:      'Du hast einen Stein gefunden! 🪨',
      untertitel: 'Fast geschafft – nur noch einer fehlt!',

      frage: 'Wie haben dir unsere Gipssteine bisher gefallen?',

      optionen: [
        { label: 'Ich bin noch am Schauen', wert: 'Noch schauen' },
        { label: 'Ich bin sehr begeistert!', wert: 'Begeistert' },
        { label: 'Ich würde gerne mehr erfahren', wert: 'Mehr erfahren' },
        { label: 'Anderes…', wert: '__other__' },
      ],
    },

    // ── Stein 🟠 (orange) ───────────────────────────────────────
    {
      id:    'orange',
      emoji: '🟠',
      farbe: '#f39200',
      textFarbe: '#1a1a1a',
      logoFarbe: '#f39200',

      bildUrl: 'https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/stein-orange.png',
      bubble: 'Na endlich – ich warte schon!',

      titel:      'Letzter Stein!',
      untertitel: 'Du hast alle gefunden – fast!',

      frage: 'Was hält dich noch davon ab, die Steine zu kaufen?',

      optionen: [
        { label: 'Ich bin mir beim Preis unsicher', wert: 'Preis' },
        { label: 'Ich weiß nicht ob es passt', wert: 'Passung' },
        { label: 'Ich kaufe gleich!', wert: 'Kaufbereit' },
        { label: 'Anderes…', wert: '__other__' },
      ],
    },

  ], // ende steine[]

  // ----------------------------------------------------------
  // Warenkorb – Shopify Varianten-IDs (versteckte Produkte)
  // ----------------------------------------------------------
  cart: {
    gratisteinVariantId:  53195106320723,  // "Gratis-Stein" (0,00 EUR)
    regenbogenVariantId:  53195106222419,  // "kajuREGENBOGEN" (0,00 EUR)
  },

  // ----------------------------------------------------------
  // Logo Farben (fix, nicht spielbar)
  // ----------------------------------------------------------
  logo: {
    bogenFarbe: '#3D1C0B',  // Dunkelbraun – bleibt immer so
  },

}; // ende KAJU_CONFIG
